"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Column = void 0;
const col_1 = __importDefault(require("antd/lib/col"));
exports.Column = col_1.default;
exports.default = exports.Column;